export const LogoMark = ({ size = "md", className = "" }) => {
  const h = { sm: "h-6", md: "h-8 md:h-9", lg: "h-12 md:h-14" };
  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src="/warnrs-logo.png?v=2"
        alt="WARNRS INDUSTRIES PTY LTD"
        className={`${h[size]} w-auto object-contain`}
      />
    </span>
  );
};
